module.exports = __webpack_public_path__ + "img/12.a52ecfc4.png";